import React, { useEffect } from 'react';
import ButtonLink, { AnchorLink } from 'components/common/ButtonLink';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import config from 'appconfig';
import t from 'modules/i18n/intl';
import { setSwitchUserEmail } from 'modules/mac/duck/actions/configUser';
import { selectIsMemberOfGroup, selectSwitchedUser } from 'modules/mac/duck/selectors';
import { fetchConsentHubLink } from 'modules/mac/duck/actions/consentHub';
import { selectConsentHubLink } from 'modules/mac/duck/selectors/consentHub';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  font-size: smaller;
  gap: 24px;
  line-height: 28px;
  font-weight: 500;
`;

export const TopMenuMAC = () => {
  const dispatch = useDispatch();
  const userEmail = useSelector(selectSwitchedUser);
  const hasAccessToSwitchUserFunctionality = useSelector(selectIsMemberOfGroup);
  const consentHubLink = useSelector(selectConsentHubLink);

  useEffect(() => {
    if (consentHubLink) {
      const { preferencesCenterUrl } = consentHubLink;
      window.location.href = preferencesCenterUrl;
    }
  }, [consentHubLink]);

  return (
    <Wrapper data-cy="mac-header-line">
      {userEmail && (
        <AnchorLink href={config.emailMAC(userEmail)} data-cy="mac-header-line-email">
          {userEmail}
        </AnchorLink>
      )}
      <AnchorLink href={config.billingDetailsMAC} data-cy="mac-header-line-billing-details">
        {t('mac.menu.billing-details')}
      </AnchorLink>
      {hasAccessToSwitchUserFunctionality ? (
        <AnchorLink href={config.switchUserMAC} data-cy="mac-header-line-switch-user">
          {t('mac.menu.switch-user')}
        </AnchorLink>
      ) : null}
      <ButtonLink
        onClick={() => {
          dispatch(fetchConsentHubLink());
        }}
        data-cy="mac-header-line-email-preferences"
      >
        {t('mac.menu.email-preferences')}
      </ButtonLink>
      <AnchorLink href={config.support} data-cy="mac-header-line-get-help">
        {t('mac.menu.get-help')}
      </AnchorLink>
      <AnchorLink href={config.marketplaceUrl} data-cy="mac-header-line-marketplace">
        {t('mac.menu.marketplace')}
      </AnchorLink>
      <AnchorLink href={config.switchAccountMAC} data-cy="mac-header-line-switch-account">
        {t('mac.menu.switch-account')}
      </AnchorLink>
      <AnchorLink
        href={config.logOutMAC}
        onClick={() => dispatch(setSwitchUserEmail(''))}
        data-cy="mac-header-line-log-out"
      >
        {t('mac.menu.log-out')}
      </AnchorLink>
    </Wrapper>
  );
};
